export const adaptDelegacion = (delegacionData) => {
    return {
        id: delegacionData?.idDelegacion,
        idRegion: delegacionData?.idRegion,
        displayName: delegacionData?.descripcion,
        name: delegacionData?.descripcion,
        cod: delegacionData?.cod_Delegacion
    }
}

export const adaptDelegacionArray = (
    delegaciones,
    permiteOpcTodas = true
) => {
    let adapDelegaciones = structuredClone(delegaciones?.allDelegaciones || delegaciones?.allDelegacionesByUsuario)
        ?.filter(x => x.idDelegacion !== 1).map(delegacion =>
            adaptDelegacion(delegacion)
        );

    if (delegaciones?.allDelegacionesByUsuario?.some(x => x.idDelegacion === 1) && permiteOpcTodas) adapDelegaciones.unshift(itemTodos)

    return adapDelegaciones;
}

export const adaptDelegacionTodosArray = (
    delegaciones
) => {
    let adapDelegaciones = structuredClone(delegaciones?.allDelegaciones || delegaciones?.allDelegacionesByUsuario)
        ?.filter(x => x.idDelegacion !== 1).map(delegacion =>
            adaptDelegacion(delegacion)
        );

    if (delegaciones?.allDelegacionesByUsuario?.some(x => x.idDelegacion === 1)) adapDelegaciones.unshift(itemTodosAux)

    return adapDelegaciones;
}

export const adaptDelegacionWithoutAllArray = (delegaciones) => {
    let adapDelegaciones = structuredClone(delegaciones?.allDelegaciones || delegaciones?.allDelegacionesByUsuario)
        ?.filter(x => x.idDelegacion !== 1).map(delegacion =>
            adaptDelegacion(delegacion)
        );
    return adapDelegaciones;
}


export const adaptDelegacionReclamosArray = (delegaciones, includeAllOption = true) => {
    let adaptDelegaciones = structuredClone(delegaciones?.allDelegaciones || delegaciones?.allDelegacionesByUsuario)
        ?.filter(x => x.idDelegacion !== 1).map(delegacion =>
            adaptDelegacion(delegacion)
        );

    if (includeAllOption) {
        adaptDelegaciones.unshift(itemTodosReclamo);
    }

    return adaptDelegaciones;
};


export const adaptDelegacionNotificacionesArray = (
    delegaciones
) => {
    let adaptDelegaciones = structuredClone(delegaciones?.allDelegaciones || delegaciones?.allDelegacionesByUsuario)
        ?.filter(x => x.idDelegacion !== 1).map(delegacion =>
            adaptDelegacion(delegacion)
        );

    adaptDelegaciones.unshift(itemTodosActivo)

    return adaptDelegaciones;
}


export const adaptDelegacionLiquidacionArray = (
    delegaciones,
    permiteOpcTodas = true
) => {
    let adapDelegaciones = structuredClone(delegaciones?.delegacionesConProfesionalesActivosByIdTipoProfesional)
        ?.filter(x => x.idDelegacion !== 1).map(delegacion =>
            adaptDelegacion(delegacion)
        );

    return adapDelegaciones;
}


const itemTodos = {
    id: null,
    displayName: 'TODAS',
    name: 'TODAS',
    cod: 'A001'
};

const itemTodosAux = {
    id: 1,
    displayName: 'TODAS',
    name: 'TODAS',
    cod: 'A001'
};

const itemTodosReclamo = {
    id: -1,
    displayName: 'TODAS',
    name: 'TODAS',
    cod: 'A001'
};

const itemTodosActivo = {
    id: 1,
    displayName: 'TODAS',
    name: 'TODAS',
    cod: 'A001'
};
